import React from 'react';

// Plain CSS progress bar — no charting library, consistent with the rest of
// this codebase. Lifted out of TrendsTab so the owner's dashboard renders the
// identical bar rather than a second copy that drifts.
export default function Bar({ label, pct, sublabel }) {
  return (
    <div style={{ marginBottom: 8 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12.5, marginBottom: 2 }}>
        <span>{label}</span>
        <span style={{ color: 'var(--good)' }}>{sublabel}</span>
      </div>
      <div style={{ height: 8, borderRadius: 4, background: 'var(--card-2)', overflow: 'hidden' }}>
        <div style={{ height: '100%', width: `${Math.min(100, pct)}%`, background: 'var(--good)', borderRadius: 4 }} />
      </div>
    </div>
  );
}
